import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'percent',
  renderInput: ({ field, value, onChange }) => (
    <div className="flex items-center gap-1">
      <input
        type="number"
        value={(value as number) ?? ''}
        onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
        placeholder={field.isRequired ? undefined : '0'}
        min={0}
        max={100}
        step={0.01}
        className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm text-text-primary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
      />
      <span className="flex-shrink-0 text-sm text-text-secondary">%</span>
    </div>
  ),
  renderCell: (_field, value) => {
    if (value == null) return '—';
    return `${Number(value).toFixed(2)}%`;
  },
  validate: (value, field) => {
    if (value == null) return field.isRequired ? 'Pole wymagane' : null;
    const num = Number(value);
    if (isNaN(num)) return 'Musi być liczbą';
    if (num < 0 || num > 100) return 'Zakres: 0–100%';
    return null;
  },
  defaultValue: null,
});
